(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.ConfirmDialog = (function(superClass) {
    extend(ConfirmDialog, superClass);

    function ConfirmDialog() {
      ConfirmDialog.__super__.constructor.call(this);
      this.layoutSource = null;
      this.layoutUrl = null;
      this.modalOptions = {
        backdrop: true
      };
      this.classes = 'small_dialog';
      L.extend(this, L.Mixin.Events);
      this.destroyOnYes = true;
      this.destroyOnNo = true;
      this.content = {
        yesClass: 'btn-primary',
        yes: 'Yes',
        no: 'No',
        body: 'Are you sure you want to continue?',
        title: 'Confirm'
      };
    }

    ConfirmDialog.prototype.setContent = function(content) {
      if (content == null) {
        content = {};
      }
      return this.content = $.extend(this.content, content);
    };

    ConfirmDialog.prototype.afterLoadLayout = function(selector, response) {
      this.dialog.html($('.confirm-dialog-template').render(this.content));
      this.openDialog();
      this.fire('confirm:loaded');
      this.dialog.find('.confirm-yes, .save-btn').on('click', (function(_this) {
        return function(e) {
          _this.response = true;
          _this.fire('confirm:yes', e);
          if (_this.destroyOnYes) {
            return _this.destroy();
          }
        };
      })(this));
      return this.dialog.find('.confirm-no, [data-dismiss="modal"]').on('click', (function(_this) {
        return function(e) {
          return _this.fire('confirm:no', e);
        };
      })(this));
    };

    ConfirmDialog.prototype.destroy = function() {
      if (this.isDestroyed()) {
        return;
      }
      this.fire('confirm:destroyed');
      this.clearAllEventListeners();
      return ConfirmDialog.__super__.destroy.call(this);
    };

    return ConfirmDialog;

  })(DialogHandler);

}).call(this);
